import React from 'react'
import PropTypes from 'prop-types'
import ContentWrapper from '../shared/content-wrapper'
import CtaButton from '../buttons/cta-button'
import NormalText from '../texts/normal-text'
import Icon from '../icons/icon'
import HeadingGamma from '../headings/heading-gamma'
import HeadingDelta from '../headings/heading-delta'
import SignForm from '../shared/sign-form'
import { Link } from 'react-router-dom'

const Success = props => (
  <ContentWrapper>
    <SignForm>
      <HeadingGamma>Welcome to Chairbids, {props.userName}!</HeadingGamma>
      <HeadingDelta thin>
        You have successfully created your account and verified your email.
      </HeadingDelta>
      <div className='prominent-icon'>
        <Icon name='finished-event' />
      </div>
      <NormalText>
        {props.isProfileCompleted
          ? 'Your are ready to go. You can review all of your account details under My Profile'
          : 'You can now complete your profile with a payment method and a delivery address.'}
      </NormalText>
      <div className='top-space bottom-space'>
        <CtaButton
          text={
            props.isProfileCompleted ? 'View My Profile' : 'Add Payment Method'
          }
          iconName='user-profile'
          onClick={props.onCompleteProfileButtonClick}
        />
      </div>
      <NormalText>
        Or... you can do it later and start exploring now!
        <Link to='/explore' className='single-link block'>
          Go to dashboard
        </Link>
      </NormalText>
    </SignForm>
  </ContentWrapper>
)

Success.propTypes = {
  // injected by decorator
  onCompleteProfileButtonClick: PropTypes.func,
  userName: PropTypes.string,
  isProfileCompleted: PropTypes.bool
}

export default Success



// WEBPACK FOOTER //
// ./src/ui/email-verification/Success.js